import { AxiosResponse } from 'axios';
import api from './Api'

export const getEventList = (): Promise<AxiosResponse<IEventBoard[], any>> => {
    return api.get(`/mobile/eventBoard`)
}
export const getEventById = (id: string): Promise<AxiosResponse<IEventBoardDetail, any>> => {
    return api.get(`/mobile/eventBoard/${id}`)
}

export const getAllByIsShowIsTrue = () => {
    return api.get<IEventBoard[]>(`/mobile/eventBoard/show`)
}
